import ChartController from "elements/chart/chart-controller";
import { ChartType } from "shared/datamodel/schemas/chart";
import { placeChart } from "shared/datamodel/chart";
import { createEmptyContext } from "elements/utils";

export default class ChartGhostController extends ChartController {
  constructor(chartType: ChartType) {
    const element = placeChart({ x: 0, y: 0 }, chartType).item;
    super("dummy", element, createEmptyContext());
  }
}
